import COUNTRIES from '../../client/new-design/constants/countries';

// TODO: update method getCountryNameByCode by putting toLowerCase
/**
 * Get the name of the country by its code
 * @param {string} code - The country code
 * @return {string} The country name
 * @category SHARED
 * @subcategory helpers
 * @module getCountryNameByCode
 */
const getCountryNameByCode = (value) => {
  const userCountry = COUNTRIES.find(({ code }) => value === code);
  return userCountry ? userCountry.name : '';
};

const getCountryCodeByCountryName = (countryName) => {
  const country = COUNTRIES.find(({ name }) => name.toLowerCase() === countryName?.toLowerCase());
  return country?.code || '';
};

export {
  getCountryNameByCode as default,
  getCountryCodeByCountryName,
};
